<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  name: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
  src?: string
}>(), {
  size: 'md',
})

const initials = computed(() => {
  return props.name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join('')
})
</script>

<template>
  <span
    :class="[
      'rounded-full flex items-center justify-center flex-shrink-0 font-bold overflow-hidden',
      {
        'w-7 h-7 text-[11px]': size === 'sm',
        'w-10 h-10 text-[14px]': size === 'md',
        'w-14 h-14 text-[18px]': size === 'lg',
        'w-20 h-20 text-[28px]': size === 'xl',
      },
    ]"
    :style="!src ? 'background: linear-gradient(135deg, #A78BFA, #6366F1); color: #fff;' : undefined"
  >
    <img
      v-if="src"
      :src="src"
      :alt="name"
      :class="[
        'rounded-full object-cover w-full h-full',
      ]"
    />
    <template v-else>{{ initials }}</template>
  </span>
</template>
